module.exports = __webpack_public_path__ + "static/img/087.07a08ddb.png";